import { defineMessages } from 'react-intl';

export default defineMessages({
  ASSIGNMENT_TITLE: {
    defaultMessage: '{assignmentTitle}<b>(coef. {coefficient, number})</b>',
  },
} as const);
